<template>
  <div></div>
</template>

<script>
export default {
  props: ["msgObj"]
}
</script>

<style>
</style>